import * as React from "react";
import { useHistory } from "react-router-dom";
import History from "@material-ui/icons/History";

import { Button } from "jazasoft";

const HistoryButton = props => {
  const { i18nKey, record } = props;
  const history = useHistory();

  const onClick = () => {
    history.push(`/library/${i18nKey}/${record.id}/history`);
  };

  return (
    <Button label="History" onClick={onClick}>
      <History />
    </Button>
  );
};

export default HistoryButton;
